/**
 * @see https://umijs.org/docs/max/access#access
 */
import { ROLE_TYPE } from '@/utils/const';

export default function access(initialState: any) {
  const {
    role,
    orgName,
  } = initialState ?? {};
  console.log('access role :>> ', role);
  return {
    role,
    orgName,

    reseller_menu: role === ROLE_TYPE.ADMIN || role === ROLE_TYPE.MEDIUM,


    reseller_typeRule_menu: role === ROLE_TYPE.ADMIN,


    reseller_account_menu: role === ROLE_TYPE.ADMIN || role === ROLE_TYPE.MEDIUM,
    reseller_account_add: role === ROLE_TYPE.ADMIN || role === ROLE_TYPE.MEDIUM,


    student_menu: true,
    student_add: role === ROLE_TYPE.MEDIUM || role === ROLE_TYPE.PRIMARY,
    

    finance_menu: true,


    finance_summaryData_menu: true,
  };
}
